import i18n from '../i18n';
import { ErrorType } from '../shared/payloads/base-payloads';
import { ApiError } from '../services/api/Network';

/**
 * Translates an ErrorType to a localized error message
 * @param errorType The ErrorType to translate
 * @returns Localized error message
 */
export function translateError(errorType: ErrorType): string {
  const key = `errors.${errorType}`;
  const translated = i18n.t(key);

  // If translation not found, return the error type itself
  if (translated === key) {
    return errorType;
  }

  return translated;
}

/**
 * Translates an error to a localized error message
 * @param error The error (can be ApiError, Error, or string)
 * @returns Localized error message
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return translateError(error.type);
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return i18n.t('errors.Generic');
}
